import {ApiClientService, EntityApiService} from '@dofleini/security';

import {authentication} from '@/settings';

class ExpedientApiService extends EntityApiService {

  updateProcess = ({_id, ...params}) => {
    return ApiClientService.patch(this.getPath(`/${_id}/process`), params);
  }

  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }

  getByProposalId = (id, params) => {
    return ApiClientService.get(this.getPath(`/proposal/${id}`), params);
  }

  updateStepData = ({_id, stepId, ...params}) => {
    return ApiClientService.patch(this.getPath(`/${_id}/finish/${stepId}`), params);
  }

  exportExcel = async (params) => {
    return ApiClientService.post(this.getPath('/export?format=excel'), params);
  }

  searchProcessed = (params) => {
    return ApiClientService.post(this.getPath('/processed/search'), params);
  }

  processStepBack = ({id, ...rest}) => {
    return ApiClientService.post(this.getPath(`/step-back/${id}`), rest);
  }

  onatDataUpdate = ({id}) => {
    return ApiClientService.get(this.getPath(`/onat/${id}`));
  }

  assignResponsible = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/assign-responsible`, params), params, config);
  }

  updateStatus = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/status`, params), params, config);
  }

  searchReduced = (params, config) => {
    return ApiClientService.post(this.getPath('/search/reduced', params), params, config);
  }

  companySync = (params, config) => {
    return ApiClientService.post(this.getPath('/sync/companies', params), params, config);
  }
}

export default new ExpedientApiService(`${authentication.path}/api/expedients`);
